import { z } from 'zod';
import { CAMPAIGN_SEND_RAILS } from '../constants/campaignSendRail.js';
import { templateVariableDefSchema, templateVariablesSchema } from '../mail/emailTemplateVariables.js';
export const emailTemplateRenderModeSchema = z.enum(['text', 'html', 'blocks']);
export const emailTemplateCreateSchema = z.object({
    project_id: z.string().uuid(),
    name: z.string().min(1).max(200),
    category: z.string().max(64).default('general'),
    subject_template: z.string().min(1).max(998),
    body_text_template: z.string().min(1).max(100_000),
    body_html: z.string().max(500_000).nullable().optional(),
    render_mode: emailTemplateRenderModeSchema.optional(),
    body_blocks: z.unknown().nullable().optional(),
    variables_schema: templateVariablesSchema.optional(),
    track_opens: z.boolean().optional(),
    track_link_clicks: z.boolean().optional(),
    tags: z.array(z.string().max(64)).max(16).optional(),
    archived: z.boolean().optional(),
});
export const emailTemplateTagsSchema = z
    .array(z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]*:[a-zA-Z0-9_-]+$/))
    .max(16);
export const emailTemplateUpdateSchema = emailTemplateCreateSchema
    .partial()
    .omit({ project_id: true })
    .extend({
    variables_schema: templateVariablesSchema.optional(),
});
export { templateVariableDefSchema, templateVariablesSchema };
export const campaignSettingsPatchSchema = z.object({
    send_hour_start: z.number().int().min(0).max(23).optional(),
    send_hour_end: z.number().int().min(0).max(23).optional(),
    weekdays_only: z.boolean().optional(),
    exit_on_open_deal: z.boolean().optional(),
    send_rail: z.enum(CAMPAIGN_SEND_RAILS).optional(),
});
export const campaignSimulateSchema = z.object({
    lead_id: z.string().uuid(),
    variant_id: z.string().uuid().optional(),
    assumed_tags: z.array(z.string().min(1)).max(20).optional(),
    assumed_status: z.string().min(1).max(64).optional(),
});
export const emailTemplatePreviewSchema = z.object({
    project_id: z.string().uuid(),
    lead_id: z.string().uuid().optional(),
    subject_template: z.string().min(1).max(998),
    body_text_template: z.string().max(100_000).optional(),
    body_html: z.string().max(500_000).optional(),
    body_blocks: z.unknown().optional(),
    render_mode: emailTemplateRenderModeSchema.optional(),
});
//# sourceMappingURL=emailTemplate.js.map